import React, { useEffect, useRef, useState } from 'react';
import { fluid } from '../utils/responsive';
import { COLORS } from '../utils/constants';
import ArrowRight from '../../../pages/userManagementV2/dashboardV3/arrow-single-right.svg';

export const PAGE_SIZE_OPTIONS = [20, 40, 60, 100];

// "1-20 of 248 ˅" — click to pick how many rows a page shows.
const PageSizeRange = ({ label, pageSize, onChange, options = PAGE_SIZE_OPTIONS }) => {
    const [open, setOpen] = useState(false);
    const ref = useRef(null);

    useEffect(() => {
        if (!open) return undefined;
        const close = (e) => {
            if (ref.current && !ref.current.contains(e.target)) setOpen(false);
        };
        document.addEventListener('mousedown', close);
        return () => document.removeEventListener('mousedown', close);
    }, [open]);

    return (
        <div ref={ref} style={{ position: 'relative' }}>
            <button
                type="button"
                onClick={() => setOpen((o) => !o)}
                title="Rows per page"
                style={{ border: 'none', background: 'transparent', padding: `0 ${fluid(4)}`, font: 'inherit', color: 'inherit', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: fluid(4) }}
            >
                {label}
                {/* Same icon as the ‹ › pager arrows, turned to point down (up while open). */}
                <img
                    src={ArrowRight}
                    alt=""
                    style={{ width: fluid(18), height: fluid(18), transform: open ? 'rotate(-90deg)' : 'rotate(90deg)', transition: 'transform 0.2s' }}
                />
            </button>
            {open && (
                <div style={{ position: 'absolute', top: 'calc(100% + 6px)', left: '50%', transform: 'translateX(-50%)', minWidth: fluid(150), backgroundColor: '#FFFFFF', borderRadius: fluid(12), boxShadow: '0 12px 32px rgba(0,0,0,0.16)', padding: fluid(6), zIndex: 40, boxSizing: 'border-box' }}>
                    {options.map((n) => {
                        const isSelected = n === pageSize;
                        return (
                            <div
                                key={n}
                                onClick={() => { onChange(n); setOpen(false); }}
                                style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: fluid(12), padding: `${fluid(8)} ${fluid(12)}`, borderRadius: fluid(8), cursor: 'pointer', fontSize: fluid(14), whiteSpace: 'nowrap', color: isSelected ? COLORS.primary : '#191919', fontWeight: isSelected ? 600 : 400, backgroundColor: isSelected ? '#F4F0FF' : 'transparent' }}
                            >
                                {n} per page
                                {isSelected && <span>✓</span>}
                            </div>
                        );
                    })}
                </div>
            )}
        </div>
    );
};

export default PageSizeRange;
